<template>
    <div class="full-width-and-height">
        <div v-if="isBlank" class="no-image-card-image"></div>
        <img
            v-else
            :src="getImageDataString(product.ProductImages[0])"
            :alt="product.ProductImages[0].AltAttribute"
        />
        <ProductPrice :product="product" />
    </div>
</template>

<script>
import ProductPrice from "./ProductPrice";

export default {
    name: "ProductImage",
    components: {
        ProductPrice
    },
    props: {
        product: {
            type: Object,
            required: true
        },
        isBlank: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        getImageDataString(imageData) {
            return `data:${imageData.MimeType};charset=utf-8;base64,${imageData.PictureBinary}`;
        }
    }
};
</script>

<style scoped lang="scss">
.full-width-and-height {
    height: 100%;
    width: 100%;
}

img{
    width: 100%;
}
</style>
